// eslint-disable-next-line import/no-anonymous-default-export
export default {
  loading: false,
  error: false,
  getProductListStatus: { data: null },
  createProductStatus: { data: null },
  updateProductStatusStatus: { data: null },
  getProductStatus: { data: null },
  deleteProductStatus: { data: null },
  uploadImageStatus: {data: null},
  getProductInterestListStatus: {data: null}
};
